import { render } from "./SGSummary.vue?vue&type=template&id=53daf78f&scoped=true"
import script from "./SGSummary.vue?vue&type=script&lang=js"
export * from "./SGSummary.vue?vue&type=script&lang=js"

import "./SGSummary.vue?vue&type=style&index=0&id=53daf78f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53daf78f"]])

export default __exports__